import React, { Component } from 'react';
import * as d3 from 'd3';
import './stats.css';

import ChartParliament from "./charts/parliament.js";
import ChartScatter from "./charts/scatter.js";
import ChartMilestones from "./charts/milestones.js"
import ChartMatrix from "./charts/matrix.js"

class Stats extends Component {
	componentDidMount() {
		this.props.SetTitle( "Analisi" );
		this.props.ShowLoading( false );
	}
  
	render() {
		return (
			<div className="stats">
				<h1 className="stats-title">Analisi</h1>
				<div className="block">
					<p>Giochiamo coi dati a nostra disposizione. Su questa pagina puoi trovare grafici e visualizzazioni che evidenziano i rapporti tra stampa, utenti dei social network, e politica. Questa pagina non contiene previsioni elettorali o giudizi sui candidati e sui loro programmi, ma solo rielaborazioni grafiche dei dati in nostro possesso relativi agli articoli e alla loro popolarità sui Social Network.</p>
				</div>
				<div className="block">
					
					<h2>Articoli e schieramenti</h2>
					
					<MilestonesAndReactions FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />
					
					<CollectionsMatrix FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />
					
					<PoliticiansMatrix2 FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />					
					
					<PoliticiansMatrix FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />					
					
					<ParliamentByVolume FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />
						
					<ParliamentByPopularity FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />
					
				</div>
				
				<hr />
				
				<div className="block">
					<h2>Fonti e media</h2>					
					<SourcesActivityByPopularity FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />
				</div>
			</div>
		);
	}
}

export default Stats;

class ParliamentByVolume extends Component {
	constructor(props) {
		super(props);
		
		this.load = this.load.bind( this );
		this.createData = this.createData.bind( this );
		
		this.state = {
			"drawing_data": {},
			"id": "ParliamentByVolume",
			"items": [],
			"loading": true,
			"updated": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/articles/number-by-collection',
			{},
			(response) => {
				this.setState( { "items": response.data, "updated": this.dateFormat( response.generated ) }, () => { this.createData(); } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	createData() {
		var total = 0,
			scale,
			data = {};
		
		this.state.items.forEach(
			function(i) {
				total += parseInt( i.volume, 10) ;
			}
		);
		scale = d3.scaleLinear()
            .domain([0,total])
            .range([0,1]);
            
        this.state.items.forEach(
			function(i) {
				data[i.slug] = { "id": i.id, "label": i.name, "slug": i.slug, "percent": scale( i.volume ) };
			}
		);
		data.ready = true;
		this.setState( { "drawing_data": data, "loading": false } );
	}
	
	render() {
		return (
			<div className="block block-chart parliament articles-parliament" id={"parliament-" + this.state.id}>
				<div className="intro">
					<h3>Se gli articoli fossero voti...</h3>					
					<p>Come sarebbe il parlamento se la copertura data dai media a ogni schieramento politico rappresentasse fedelmente le intenzioni di voto degli elettori? Questo grafico è un esercizio che non tiene conto di <b>come</b> i media parlino di uno schieramento politico. Come si usa dire: <b>l'importante è che se ne parli</b>.</p>
				</div>
				<div className={"chart " + ((this.state.loading) ? "" : "ready")}>
					<div className="chart-loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className="chart-dataviz">
						<div className="in">
							<ChartParliament DrawingData={this.state.drawing_data} ChartId={this.state.id} />
						</div>
					</div>
				</div>
				<div className="method">
					<h4>Metodo</h4>
					<p>Questa visualizzazione non rappresenta i risultati di un sondaggio elettorale. Le percentuali attribuite a ciascuno schieramento sono calcolate sulla base del numero di articoli importati dai nostri bot e da essi attribuiti ai diversi schieramenti. Si tratta più che di una proiezione dei voti, di una istantanea di quanto spazio la stampa dedica ai diversi schieramenti. I dati sono aggiornati ogni 24 ore <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}
















class ParliamentByPopularity extends Component {
	constructor(props) {
		super(props);
		
		this.load = this.load.bind( this );
		this.createData = this.createData.bind( this );
		this.dateFormat = this.dateFormat.bind( this );
		
		this.state = {
			"drawing_data": {},
			"id": "ParliamentByPopularity",
			"items": [],
			"loading": true,
			"updated": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/articles/number-by-collection',
			{},
			(response) => {
				this.setState( { "items": response.data, "updated": this.dateFormat( response.generated ) }, () => { this.createData(); } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	createData() {
		var total = 0,
			scale,
			data = {};
		
		this.state.items.forEach(
			function(i) {
				total += parseInt( i.popularity, 10) ;
			}
		);
		scale = d3.scaleLinear()
            .domain([0,total])
            .range([0,1]);
            
        this.state.items.forEach(
			function(i) {
				data[i.slug] = { "id": i.id, "label": i.name, "slug": i.slug, "percent": scale( i.popularity ) };
			}
		);
		data.ready = true;
		this.setState( { "drawing_data": data, "loading": false } );
	}
	
	render() {
		return (
			<div className="block block-chart parliament articles-parliament" id={"parliament-" + this.state.id}>
				<div className="intro">
					<h3>Se le condivisioni fossero voti...</h3>					
					<p>La base di dati è la stessa della visualizzazione precedente, ma questa volta ad attribuire i voti ai diversi schieramenti non sono il numero di articoli, ma l'indice di popolarità attribuito a questi articoli. Questa visualizzazione consente di vedere quali schieramenti generano più reazioni tra il pubblico, indipendentemente dalla copertura che ottengono dai giornali.</p>
				</div>
				<div className={"chart " + ((this.state.loading) ? "" : "ready")}>
					<div className="chart-loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className="chart-dataviz">
						<div className="in">
							<ChartParliament DrawingData={this.state.drawing_data} ChartId={this.state.id} />
						</div>
					</div>
				</div>
				<div className="method">
					<h4>Metodo</h4>
					<p>Questa visualizzazione non rappresenta i risultati di un sondaggio elettorale. Le percentuali attribuite a ciascuno schieramento sono calcolate sulla base del numero di condivisioni degli articoli importati dai nostri bot e da essi attribuiti ai diversi schieramenti. Si tratta, più che di una proiezione dei voti, di una istantanea di quanto siano attivi online i sostenitori dei diversi schieramenti. I dati sono aggiornati ogni 24 ore <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}



class SourcesActivityByPopularity extends Component {
	constructor(props) {
		super(props);
		
		this.load = this.load.bind( this );
		this.dateFormat = this.dateFormat.bind( this );
		
		this.state = {
			"id": "SourceByActivityAndPopularity",
			"items": {
				"items": [],
				"ready": false
			},
			"loading": true,
			"max_activity": 0,
			"max_popularity": 0,
			"avg_activity": 0,
			"avg_popularity": 0,
			"updated": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/sources/activity-and-popularity',
			{},
			(response) => {
				let drawingData = {
					"items": response.data,
					"ready": true
				}
				this.setState( { "items": drawingData, "max_activity": response.max_activity, "max_popularity": response.max_popularity, "avg_activity": response.avg_activity, "avg_popularity": response.avg_popularity, "loading": false, "updated": this.dateFormat( response.generated ) } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	render() {
		return (
			<div className="block block-chart scatter sources-scatter" id={"scatter-" + this.state.id}>
				<div className="intro">
					<h3>La popolarità di una fonte è correlata con la quantità di news pubblicate?</h3>					
					<p>Quali sono i siti più popolari? Quali i più attivi (in termine di news pubblicate)? Esiste una correlazione tra questi due indici? In questo grafico i punti rappresentato i siti aggregati per dominio (ad esempio "www.repubblica.it" e "espresso.repubblica.it" sono calcolati assieme, come "repubblica.it"). Più un punto è "in alto" rispetto all'asse <i>x</i>, tanto più il sito è popolare; più il punto è lontano dall'asse <i>y</i>, più il sito è attivo. La linea verde rappresenta la <i>regressione lineare</i> della serie, ovvero una proiezione statistica di quale, sulla base dei dati a disposizione, dovrebbe essere la relazione tra attività e popolarità.</p>
				</div>
				<div className={"chart " + ((this.state.loading) ? "" : "ready")}>
					<div className="chart-loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className="chart-dataviz">
						<div className="in">
							<ChartScatter DrawingData={this.state.items} ChartId={this.state.id} Updated={this.state.updated} MinX="0" MinY="0" MaxX={this.state.max_activity} MaxY={this.state.max_popularity} LabelX="Attività" LabelY="Popolarità" />
						</div>
					</div>
				</div>
				<div className="method">
					<h4>Metodo</h4>
					<p>L'attività corrisponde al numero di articoli importati e pubblicati per ogni fonte. La popolarità invece si basa sul valore medio dell'indice di popolarità degli articoli pubblicati da una determinata fonte; l'indice di popolarità è dato dai valori pesati delle condivisioni di ogni articolo su Facebook e Twitter <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}




class MilestonesAndReactions extends Component {
	constructor(props) {
		super(props);
		
		this.setDate = this.setDate.bind( this );
		this.setLoading = this.setLoading.bind( this );
		
		this.state = {
			"charts": [{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 32
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 32
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 31
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 31
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 26
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 26
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 25
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 25
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 24
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 23
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 22
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 22
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 21
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 21
			},{
				"collection":"Centro Sinistra",
				"collection_slug":"centro-sinistra",
				"milestone_id": 21
			},{
				"collection":"Sinistra",
				"collection_slug":"sinistra",
				"milestone_id": 21
			},{
				"collection":"Destra",
				"collection_slug":"destra",
				"milestone_id": 21
			},{
				"collection":"Destra",
				"collection_slug":"destra",
				"milestone_id": 18
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 17
			},{
				"collection":"Sinistra",
				"collection_slug":"sinistra",
				"milestone_id": 15
			},{
				"collection":"Destra",
				"collection_slug":"destra",
				"milestone_id": 14
			},{
				"collection":"Centro Destra",
				"collection_slug":"centro-destra",
				"milestone_id": 10
			},{
				"collection":"Centro Sinistra",
				"collection_slug":"centro-sinistra",
				"milestone_id": 9
			},{
				"collection":"Movimento 5 Stelle",
				"collection_slug":"m5s",
				"milestone_id": 7
			}],
			"id": "ActivityAndPopularityByCollectionAndMilestones",
			"items": {
				"items": [],
				"ready": false
			},
			"loading": true,
			"updated": null
		}
	}
	
	setDate(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		this.setState( { "updated": gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) } );
	}
	
	setLoading( show ) {
		this.setState( { "loading": show } );
	}
	
	render() {
		let props = this.props;
		let state = this.state;
		let setDate = this.setDate;
		let setLoading = this.setLoading;
		return (
			<div className="block block-chart milestone milestone-area" id={"milestone-" + this.state.id}>
				<div className="intro">
					<h3>Quali avvenimenti hanno influito sulla copertura mediatica di queste elezioni?</h3>					
					<p>Nel corso di questa campagna elettorale abbiamo individuato dei <a href="#/temi/">temi</a> che rappresentato degli avvenimenti importanti, e che a nostro parere avrebbero potuto influenzare l'esito del voto. Con questi grafici cercheremo di capire se hanno influenzato la copertura dei media per lo schieramento coinvolto, e come hanno reagito i Social Network.</p>
				</div>
				{
					this.state.charts.map(
						function( chart, index ) {
							return (
								<div key={"milestone-" + index + "-" + chart.collection_slug} className={"chart " + ((state.loading) ? "" : "ready")} id={"milestone-" + index + "-" + chart.collection_slug}>
									<div className="chart-loading">
										<div className="in">
											<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
												<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
													<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
													<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
												</g>
											</svg>
										</div>
									</div>
									<div className="chart-dataviz">
										<div className="in">
											<ChartMilestones Collection={chart.collection} CollectionSlug={chart.collection_slug} MilestoneId={chart.milestone_id} ChartId={"milestone-" + index + "-" + chart.collection_slug} FetchContent={props.FetchContent} BaseUrl={props.BaseUrl}  VizUrl={props.VizUrl} AnimationDuration={props.AnimationDuration} SetDate={setDate} SetLoading={setLoading} />
										</div>
									</div>
								</div>
							);
						}
					)
				}
				<div className="method">
					<h4>Metodo</h4>
					<p>L'indice di "attività" rappresenta il numero di articoli pubblicati ogni giorno dai siti che monitoriamo e che i nostri bot hanno assegnato a un determinato schieramento. L'indice di "popolarità" è invece la media quotidiana della popolarità di ogni articolo compreso nel dataset. L'indice di popolarità di un articolo è un valore pesato calcolato tenendo conto di tweet, retweet, favorites (e numero di follower di chi li fa) e di commenti, condivisioni, e reazioni su Facebook <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}








class CollectionsMatrix extends Component {
	constructor(props) {
		super(props);
		
		this.load = this.load.bind(this);
		this.dateFormat = this.dateFormat.bind(this);
		
		this.state = {
			"collections":[],
			"id": "CollectionsMatrix",
			"max":0,
			"matrix": [],
			"min":0,
			"loading": true,
			"updated": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/articles/map-by-collection-collision',
			{},
			(response) => {
				this.setState( { "matrix": response.data.matrix, "max": response.data.max, "min": response.data.min, "collections": response.data.collections, "loading": false, "updated": this.dateFormat( response.generated ) } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	render() {
		return (
			<div className="block block-chart matrix" id={"matrix-" + this.state.id}>
				<div className="intro">
					<h3>Quanti articoli parlano di più di uno schieramento? Articoli comuni indicano conflitti o convergenze?</h3>					
					<p>La matrice mostra quanti sono i punti di contatto tra i diversi schieramenti. Ovviamente, anche qui, non si parla di contenuti dei programmi elettorali, ma di come la stampa tende ad associare i gruppi partecipanti alle prossime elezioni.</p>
				</div>
				<div className={"chart " + ((this.state.loading) ? "" : "ready")}>
					<div className="chart-loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className="chart-dataviz">
						<div className="in">
							<ChartMatrix Matrix={this.state.matrix} Axis={this.state.collections} ChartId={this.state.id} Min={this.state.min} Max={this.state.max} />
						</div>
					</div>
				</div>
				<div className="method">
					<h4>Metodo</h4>
					<p>La matrice mostra gli stessi schieramenti elettorali sia sulle righe che sulle colonne. Il colore più scuro indica maggiori punti di contatto rispetto a quello più chiaro. Il colore è determinato estraendo dal nostro database solo gli articoli associati contemporaneamente ai due schieramenti <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}






class PoliticiansMatrix2 extends Component {
	constructor(props) {
		super(props);
		
		this.load = this.load.bind(this);
		this.dateFormat = this.dateFormat.bind(this);
		
		this.state = {
			"collections":[],
			"id": "PoliticiansMatrix",
			"max":0,
			"matrix": [],
			"min":0,
			"loading": true,
			"query": [
				{ "name": "S. Mattarella", "keyword": "Mattarella", "slug": "mattarella" },
				{ "name": "C. Cottarelli", "keyword": "Cottarelli", "slug": "cottarelli" },
				{ "name": "G. Massolo", "keyword": "Massolo", "slug": "massolo" },
				{ "name": "G. Giorgetti", "keyword": "Giorgetti", "slug": "giorgetti" },
				{ "name": "G. Bongiorno", "keyword": "Bongiorno", "slug": "bongiorno" },
				{ "name": "G. Sapelli", "keyword": "Sapelli", "slug": "sapelli" },
				{ "name": "G. Conte", "keyword": "Conte", "slug": "conte" },
				{ "name": "G. M. Centinaio", "keyword": "Centinaio", "slug": "centinaio" },
				{ "name": "N. Molteni", "keyword": "Molteni", "slug": "molteni" },
				{ "name": "A. Siri", "keyword": "Siri", "slug": "siri" },
				{ "name": "S. Candiani", "keyword": "Candiani", "slug": "candiani" },
				{ "name": "M. Salvini", "keyword": "Salvini", "slug": "salvini" },
				{ "name": "S. Berlusconi", "keyword": "Berlusconi", "slug": "berlusconi" },
				{ "name": "L. Di Maio", "keyword": "Di Maio", "slug": "dimaio" },
				{ "name": "M. Renzi", "keyword": "Renzi", "slug": "renzi" },
      ],
			"updated": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/articles/map-by-keywords-collision?q=' + escape( JSON.stringify( this.state.query ) ) + '&from_date=' + escape('2018-03-05 00:00:00'),
			{},
			(response) => {
				this.setState( { "matrix": response.data.matrix, "max": response.data.max, "min": response.data.min, "keywords": response.data.keywords, "loading": false, "updated": this.dateFormat( response.generated ) } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	render() {
		return (
			<div className="block block-chart matrix" id={"matrix-" + this.state.id}>
				<div className="intro">
					<h3>Come interagiscono tra loro i leader dei partiti usciti vincenti da queste elezioni e i possibili primi ministri?</h3>					
					<p>I risultati delle elezioni non hanno prodotto una netta maggioranza quindi, come ai tempi della prima repubblica, i partiti vincitori hanno iniziato a trattare su se e come formare un governo. La matrice illustra le interazioni (negli articoli di giornale) tra i leader dei partiti e quei personaggi che, a mano a mano, vengono indicati come possibili primi ministri nell'ipotetico governo che dovrebbe nascere sulle ceneri degli schieramenti che si sono sgretolati dopo la campagna elettorale. Questi dati si riferiscono agli articoli pubblicati <strong>dopo</strong> il 4 marzo 2018.</p>
				</div>
				<div className={"chart " + ((this.state.loading) ? "" : "ready")}>
					<div className="chart-loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className="chart-dataviz">
						<div className="in">
							<ChartMatrix Matrix={this.state.matrix} Axis={this.state.keywords} ChartId={this.state.id} Min={this.state.min} Max={this.state.max} />
						</div>
					</div>
				</div>
				<div className="method">
					<h4>Metodo</h4>
					<p>La matrice mostra gli stessi politici elettorali sia sulle righe che sulle colonne. Il colore più scuro indica maggiori punti di contatto rispetto a quello più chiaro. Il colore è determinato estraendo dal nostro database solo gli articoli associati contemporaneamente ai due schieramenti <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}












class PoliticiansMatrix extends Component {
	constructor(props) {
		super(props);
		
		this.load = this.load.bind(this);
		this.dateFormat = this.dateFormat.bind(this);
		
		this.state = {
			"collections":[],
			"id": "PoliticiansMatrix",
			"max":0,
			"matrix": [],
			"min":0,
			"loading": true,
			"query": [
				{ "name": "S. Mattarella", "keyword": "Mattarella", "slug": "mattarella" },
				{ "name": "S. Di Stefano", "keyword": "Di Stefano", "slug": "distefano" },
				{ "name": "G. Meloni", "keyword": "Meloni", "slug": "meloni" },
				{ "name": "M. Salvini", "keyword": "Salvini", "slug": "salvini" },
				{ "name": "S. Berlusconi", "keyword": "Berlusconi", "slug": "berlusconi" },
				{ "name": "A. Tajani", "keyword": "Tajani", "slug": "tajani" },
				{ "name": "M. E. A. Casellati", "keyword": "Casellati", "slug": "casellati" },
				{ "name": "B. Grillo", "keyword": "Grillo", "slug": "grillo" },
				{ "name": "L. Di Maio", "keyword": "Di Maio", "slug": "dimaio" },
				{ "name": "A. Di Battista", "keyword": "Di Battista", "slug": "dibattista" },
				{ "name": "R. Fico", "keyword": "Fico", "slug": "fico" },
				{ "name": "M. Renzi", "keyword": "Renzi", "slug": "renzi" },
				{ "name": "M. Martina", "keyword": "Martina", "slug": "martina" },
				{ "name": "E. Bonino", "keyword": "Bonino", "slug": "bonino" },
				{ "name": "P. Gentiloni", "keyword": "Gentiloni", "slug": "gentiloni" },
				{ "name": "P. Grasso", "keyword": "Grasso", "slug": "grasso" },
				{ "name": "L. Boldrini", "keyword": "Boldrini", "slug": "boldrini" },
				{ "name": "V. Carofalo", "keyword": "Carofalo", "slug": "carofalo" }
			],
			"updated": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/articles/map-by-keywords-collision?q=' + escape( JSON.stringify( this.state.query ) ) + '&to_date=' + escape('2018-03-04 23:59:59'),
			{},
			(response) => {
				this.setState( { "matrix": response.data.matrix, "max": response.data.max, "min": response.data.min, "keywords": response.data.keywords, "loading": false, "updated": this.dateFormat( response.generated ) } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	render() {
		return (
			<div className="block block-chart matrix" id={"matrix-" + this.state.id}>
				<div className="intro">
					<h3>Come interagiscono tra loro i leader degli schieramenti negli articoli di giornale?</h3>					
					<p>La matrice mostra quanti sono i punti di contatto tra i diversi leader di schieramento. Anche qui non si parla di contenuti dei programmi elettorali, ma di come la stampa tende ad associare i gruppi partecipanti a queste elezioni. Questa matrice utilizza i dati importati <strong>fino al</strong> 4 marzo 2018.</p>
				</div>
				<div className={"chart " + ((this.state.loading) ? "" : "ready")}>
					<div className="chart-loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className="chart-dataviz">
						<div className="in">
							<ChartMatrix Matrix={this.state.matrix} Axis={this.state.keywords} ChartId={this.state.id} Min={this.state.min} Max={this.state.max} />
						</div>
					</div>
				</div>
				<div className="method">
					<h4>Metodo</h4>
					<p>La matrice mostra gli stessi politici elettorali sia sulle righe che sulle colonne. Il colore più scuro indica maggiori punti di contatto rispetto a quello più chiaro. Il colore è determinato estraendo dal nostro database solo gli articoli associati contemporaneamente ai due schieramenti <small>(ultimo aggiornamento: {this.state.updated})</small>.</p>
				</div>
			</div>
		);
	}
}



/*
 */


// WEBPACK FOOTER //
// ./src/Elezioni/stats.js